module.exports = __webpack_public_path__ + "17fb1b9c2805f6f2e6628c0548749a37.svg";